'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    SELECCIONAR_FILTRO_PROCESOS,
    CARGA_INICIAL_PROCESOS,
    FILTRAR_PROCESOS,
    GET_TRAZA_PROCESOS,
    APLICAR_FILTROS_EJECUCIONES,
    UP_GET_SSIS_CALENDARIO_PROCESO_Agenda,
    UP_GET_SSIS_PROCESO_Datos_Ejecucion,
    AD17P_GET_LOG_PROCESO,
    SELECCION_COMBO_EJECUCION_DEMANDA,
    GET_ERRORES_PROCESO,
    CHECK_ERROR_PROCESOS,
    CHECK_ALL_ERROR_PROCESOS,
    MOSTRAR_MODAL,
    PROCESOS_MOSTRAR_MODAL_MENSAJE_RESULTADO,
    PROCESOS_MOSTRAR_MODAL,
    RESET_STORE,
    SELECCIONAR_TAB_ERROR,
    CHECK_SIN_TILDAR,
    REPROCESO_FINALIZADO,
    ACTUALIZAR_DATEPICKER,
    ERROR_FOMARTO_FECHA,
    ERROR_FECHA_POSTERIOR,
    MENSAJE_EJECUCIONDEMANDA,
    CARGAR_ARCHIVOS_EJEC_DEMANDA,
    LOADING_REPROCESO,
    LOADING_EJEC_DEMANDA,
    LIMPIAR_TABLERO,
    GET_ID_PROCESAMIENTO,
    ID_PROCESAMIENTO_SELECCIONADO,
    ERROR_FORMATO_ID_PROCESO,
    LOADING_TABLERO,
    PROCESOS_FILTRADOS_EJEC_DEMANDA,
    VALOR_ACTUAL_COMBOS_EJEC_DEMANDA,
    GET_CANTIDAD_PROCESOS,
    AGREGAR_ARCHIVO_EJECUCION_DEMANDA,
    ERROR_EJECUCIONDEMANDA,
    SET_BUSQUEDA_ARCHIVOS,
    ES_EJECUCION_DEMANDA
} from '../../Screens/Procesos/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    fecha: new Date(),
    fechaEjecDemanda: new Date(),
    tipoProceso: null,
    marcaId: null,
    proceso: null,
    procesosAdintar17: [],
    procesosFiltrado: [],
    procesosFiltradoEjecucion: [],
    feriados: [],
    procesosProgramados: [],
    administradoras: [],
    ejecucionesProcesos: [],
    ejecucionesProcesosFiltrados: [],
    procesosDocumentados: [],
    datosProcesos: [],
    datosProceso: [],
    datosProcesosEncabezado: null,
    redirect: {
        shouldRedirect: false,
        to: null,
    },
    isFetching: false,
    error: false,
    modalProcesosDocumentados: false,
    modalEjecucionDemanda: false,
    modalProcesoIndividual: false,
    modalConfirmarSalir: false,
    modalProcesoEnEjecucion: false,
    modalMensajeResultado: false,     
    nombreProceso: '',
    mensaje: '',
    nombresLabelErrores: [],
    erroresTotal: null,
    colorEstado: '',
    checkSinTildar: false,
    masDeCienRegistrosDeError: false,
    reprocesoFinalizado: false,
    actualizarDatePicker: false,
    errorFormatoFecha: false,
    esFechaPosterior: false,
    errorFormatoFechaEjecDemanda: false,
    esFechaPosteriorEjecDemanda: false,
    errorFormatoIdProceso: false,
    msjErrorCalendario: '',
    msjEjecucionDemanda: '',
    archivosEjecDemanda: [],
    archivosEjecDemandaFiltrados: [],
    archivoEjecDemandaSeleccionado: '',
    loadingReproceso: false,
    loadingEjecDemanda: false,
    listaRowIdConError: [],
    idsProcesamiento:[],
    idProcesamientoSeleccionado: undefined,
    modalDatosCuenta: {
        mostrar: false,
        titulo: '',
        mensaje: '',
    },
    loadingTablero: false,
    combosEjecucionDemanda: undefined,
    administradoraSeleccionada: undefined,
    errorEjecDemanda: false,
    textArchivo: '',
    archivoEncontrado: true,
    esEjecucionDemanda: false,
    mostrarTablero: true
};

function procesos(state = initialState, action) {
    LogHelper.In(procesos.name, state, action);
    let result;

    switch (action.type) {

        case ERROR_FORMATO_ID_PROCESO:{
            result = {
                ...state,
                errorFormatoIdProceso: action.valor
            };
            break;
        }

        case GET_ID_PROCESAMIENTO:{
            result = {
                ...state,
                idsProcesamiento: action.valor
            };
            break;
        }

        case ID_PROCESAMIENTO_SELECCIONADO:{
            result = {
                ...state,
                idProcesamientoSeleccionado: action.valor
            };
            break;
        }

        case LOADING_REPROCESO: {
            result = {
                ...state,
                loadingReproceso: action.valor,
            };
            break;
        }

        case LOADING_EJEC_DEMANDA: {
            result = {
                ...state,
                loadingEjecDemanda: action.valor,
            };
            break;
        }

        case LOADING_TABLERO: {
            result = {
                ...state,
                loadingTablero: action.loadingState,
            };
            break;
        }

        case CARGAR_ARCHIVOS_EJEC_DEMANDA: {
            result = {
                ...state,
                archivosEjecDemanda: action.archivosEjecDemanda,
                archivosEjecDemandaFiltrados: action.archivosEjecDemanda
            };
            break;
        }

        case MENSAJE_EJECUCIONDEMANDA: {
            result = {
                ...state,
                msjEjecucionDemanda: action.mensaje,
            };
            break;
        }

        case ACTUALIZAR_DATEPICKER: {
            result = {
                ...state,
                fecha: action.fecha,
                actualizarDatePicker: action.actualizarDatePicker,
            };
            break;
        }

        case CHECK_SIN_TILDAR: {
            result = {
                ...state,
                checkSinTildar: action.checkSinTildar,
            };
            break;
        }
        case REPROCESO_FINALIZADO: {
            result = {
                ...state,
                reprocesoFinalizado: action.reprocesoFinalizado,
            };
            break;
        }
        case SELECCIONAR_FILTRO_PROCESOS: {
            result = { ...state, [action.filtro]: action.valor };
            break;
        }
        case ERROR_FOMARTO_FECHA: {
            result = {
                ...state,
                [action.campo]: action.valor,
                msjErrorCalendario: 'Formato incorrecto',
            };
            break;
        }

        case ERROR_FECHA_POSTERIOR: {
            result = {
                ...state,
                [action.campo]: action.valor,
                msjErrorCalendario: 'Fecha incorrecta',
            };
            break;
        }

        case SELECCION_COMBO_EJECUCION_DEMANDA: {
            result = { 
                ...state, 
                [action.campo]: action.valor,
                archivoEjecDemandaSeleccionado: undefined };
            break;
        }
        
        case MOSTRAR_MODAL: {
            switch (action.modalId) {
                case 1: {
                    result = { ...state, modalProcesosDocumentados: action.abrirCerrar, modalEjecucionDemanda: false, modalProcesoIndividual: false, modalProcesoEnEjecucion: false };
                    break;
                }
                case 2: {
                    result = { ...state, errorFormatoFechaEjecDemanda: false, errorFormatoIdProceso: false, modalProcesosDocumentados: false, modalEjecucionDemanda: action.abrirCerrar, modalProcesoIndividual: false, modalProcesoEnEjecucion: false };
                    break;
                }
                case 3: {
                    result = {
                        ...state,
                        modalProcesosDocumentados: false,
                        modalEjecucionDemanda: false,
                        modalProcesoIndividual: action.abrirCerrar,
                        modalProcesoEnEjecucion: false//,
                        //datosProcesos: [],
                        //datosProcesosEncabezado: null,
                    };
                    break;
                }
                case 4: {
                    result = { ...state, modalConfirmarSalir: action.abrirCerrar };
                    break;
                }
                case 5: {
                    result = {
                        ...state,
                        modalProcesosDocumentados: false,
                        modalEjecucionDemanda: false,
                        modalProcesoIndividual: false,
                        modalProcesoEnEjecucion: action.abrirCerrar,
                        nombreProceso: action.nombreProceso,
                        mensaje: action.mensaje,
                    };
                    break;
                }
                /**
                 * ADT-1220
                 * Adintar17 - Tablero de ejecuciones: No se reprocesa correctamente el archivo cuando se desestiman los registros
                 * Segun hablado con Silvia Serra para reprocesar, se debe por lo menos seleccionar un registro a reprocesar,
                 * si desestima todo debe mostrar una advertencia indicando que por lo menos debe seleccionar un registro a reprocesar
                 * para efectuar la accion de Reprocesar
                 */
                case 6: {
                    let modalDatosCuenta = {
                        ...state.modalDatosCuenta,
                        mostrar: action.mostrar,
                        titulo: action.titulo,
                        mensaje: action.mensaje,
                    };
                    result = {
                        ...state,
                        modalDatosCuenta: modalDatosCuenta,
                    };
                    break;
                }
            }
            break;
        }

        case PROCESOS_MOSTRAR_MODAL_MENSAJE_RESULTADO: {
            result = {
                ...state,
                modalMensajeResultado: action.mensaje,
            }
            break;
        }

        case PROCESOS_MOSTRAR_MODAL: {
            result = {
                ...state,
                [action.nombreModal]: action.mostrarModal,
            };
            break;
        }
        
        case FILTRAR_PROCESOS: {
            let procesosFiltrado = JSON.parse(JSON.stringify(state.procesos));

            switch (action.filtro) {
                case 'marcaId': {
                    if (action.valor != '0') {
                        //Se contemplan aquellos procesos con AdministradoraId = NULL, correspondiente a procesos "genéricos"
                        procesosFiltrado = action.valor == '-1' ?
                        procesosFiltrado.filter((proceso) => proceso.AdministradoraId == null)
                        :
                        procesosFiltrado.filter((proceso) => proceso.AdministradoraId == action.valor)
                    }
                    if (state.tipoProceso && state.tipoProceso != '0') {
                        procesosFiltrado = procesosFiltrado.filter((proceso) => proceso.TipoProceso == state.tipoProceso);
                    }
                    break;
                }
                case 'tipoProceso': {
                    if (action.valor != 0) {
                        // SE APLICA ESTA CONDICIÓN PORQUE EL VALOR "0" CORRESPONDE A LA SELECCION "TODOS", POR LO QUE NO CORRESPONDE
                        procesosFiltrado = procesosFiltrado.filter((proceso) => proceso.TipoProceso == action.valor);
                    }
                    if (state.marcaId && state.marcaId != '0') {
                        //Se contemplan aquellos procesos con AdministradoraId = NULL, correspondiente a procesos "genéricos"
                        procesosFiltrado = state.marcaId == '-1' ?
                        procesosFiltrado.filter((proceso) => proceso.AdministradoraId == null)
                        :
                        procesosFiltrado.filter((proceso) => proceso.AdministradoraId == state.marcaId)
                    }
                    break;
                }
            }

            result = { ...state, procesosFiltrado: procesosFiltrado };
            break;
        }

        case CARGA_INICIAL_PROCESOS: {
            /**
             * ADT-1220
             * Adintar17 - Tablero de ejecuciones: No se reprocesa correctamente el archivo cuando se desestiman los registros
             * Segun hablado con Silvia Serra para reprocesar, se debe por lo menos seleccionar un registro a reprocesar,
             * si desestima todo debe mostrar una advertencia indicando que por lo menos debe seleccionar un registro a reprocesar
             * para efectuar la accion de Reprocesar
             */
            let modalDatosCuenta = {
                ...state.modalDatosCuenta,
                mostrar: action.mostrar,
                titulo: action.titulo,
                mensaje: action.mensaje,
            };
            result = {
                ...state,
                administradoras: action.resultado.administradoras,
                administradorasFiltradas: action.resultado.administradoras,
                procesos: action.resultado.procesos,
                procesosFiltrado: action.resultado.procesos,
                procesosFiltradoEjecucion: action.resultado.procesos,
                feriados: action.resultado.feriados,
                procesosProgramados: action.resultado.procesosProgramados,
                fecha: new Date(),
                /**
                 * ADT-1220
                 * Adintar17 - Tablero de ejecuciones: No se reprocesa correctamente el archivo cuando se desestiman los registros
                 * Segun hablado con Silvia Serra para reprocesar, se debe por lo menos seleccionar un registro a reprocesar,
                 * si desestima todo debe mostrar una advertencia indicando que por lo menos debe seleccionar un registro a reprocesar
                 * para efectuar la accion de Reprocesar
                 */
                modalDatosCuenta: modalDatosCuenta,
            };
            break;
        }
        case GET_TRAZA_PROCESOS: {
            result = { ...state, ejecucionesProcesos: action.ejecucionesProcesos };
            break;
        }

        case GET_CANTIDAD_PROCESOS: {
            result = { ...state, procesosProgramados: action.procesosProgramados };
            break;
        }
        case UP_GET_SSIS_CALENDARIO_PROCESO_Agenda: {
            result = { ...state, procesosDocumentados: action.procesosDocumentados };
            break;
        }
        case UP_GET_SSIS_PROCESO_Datos_Ejecucion: {
            result = { ...state, datosProcesos: action.datosProcesos, datosProcesosEncabezado: action.datosProcesosEncabezado[0] };
            break;
        }
        case AD17P_GET_LOG_PROCESO: {
            result = { ...state, datosProceso: action.datosProceso};
            break;
        }
        case GET_ERRORES_PROCESO: {
            if (!action.errores || !action.errores.length > 0) {
                result = { ...state, erroresProceso: action.errores, mostrarTablero: action.mostrarTablero };
            } else {
                if (action.errores.length > 100 && action.colorEstado == 'ROJO') {
                    state.masDeCienRegistrosDeError = true;
                    action.errores.pop(); //En caso que vengan 101 registros elimino el ultimo
                } else {
                    state.masDeCienRegistrosDeError = false;
                }
                result = {
                    ...state,
                    erroresProceso: action.errores,
                    mostrarTablero: action.mostrarTablero,
                    nombresLabelErrores: action.nombres,
                    erroresTotal: action.erroresTotal,
                    labelErrorActiva: action.nombres[0],
                    colorEstado: action.colorEstado,
                    listaRowIdConError: action.listaRowIdConError,
                };
            }
            break;
        }
        case SELECCIONAR_TAB_ERROR: {
            result = { ...state, erroresProceso: action.erroresSeleccionados, labelErrorActiva: action.label };
            break;
        }
        case CHECK_ERROR_PROCESOS: {
            let procesosAux = JSON.parse(JSON.stringify(state.erroresProceso));

            procesosAux.map((error) => {
                if (error.RowId == action.rowId) {
                    error[action.accion] = !error[action.accion];
                    if (action.accion == 'desestimar' && error.desestimar) error.reprocesar = false;
                    if (action.accion == 'reprocesar' && error.reprocesar) error.desestimar = false;
                }
            });

            result = { ...state, erroresProceso: procesosAux, desestimaTodos: false, reprocesaTodos: false };
            break;
        }
        case CHECK_ALL_ERROR_PROCESOS: {
            if (action.accion == 'clean') {
                result = { ...state, desestimaTodos: false, reprocesaTodos: false };
                break;
            } else {
                let desestima = !state.desestimaTodos && action.accion == 'desestimar';
                let reprocesa = !state.reprocesaTodos && action.accion == 'reprocesar';

                let procesosAux = JSON.parse(JSON.stringify(state.erroresProceso));

                procesosAux.map((error) => {
                    if (error.Descripcion.toUpperCase() != 'NOTA') {
                        if (desestima) {
                            error.desestimar = true;
                            error.reprocesar = false;
                        } else if (reprocesa) {
                            error.desestimar = false;
                            error.reprocesar = true;
                        } else {
                            error.desestimar = false;
                            error.reprocesar = false;
                        }
                    }
                });

                result = { ...state, erroresProceso: procesosAux, desestimaTodos: desestima, reprocesaTodos: reprocesa };
                break;
            }
        }

        case LIMPIAR_TABLERO: {
            switch (action.seccion){
                case "CajasProcesos" :{
                    result = {...state,
                        datosProcesos: [],
                        datosProcesosEncabezado:null
                    };                    
                    break;
                }
                case "CajasTablero" :{
                    result = {...state,
                        ejecucionesProcesosFiltrados: []
                    };                  
                    break;
                }
            }
            break;
        }

        case APLICAR_FILTROS_EJECUCIONES: {
            let procesosTodo = JSON.parse(JSON.stringify(state.ejecucionesProcesos));
            let administradorasAux = JSON.parse(JSON.stringify(state.administradoras));
            let tipoProceso = state.tipoProceso;
            let proceso = state.proceso;
            let marcaId = state.marcaId;

            if (marcaId && marcaId != '0') administradorasAux = administradorasAux.filter((adm) => (adm.Id = marcaId));

            if (tipoProceso && tipoProceso != '0') procesosTodo = procesosTodo.filter((proc) => proc.TipoProceso == tipoProceso);

            if (proceso && proceso != '0') procesosTodo = procesosTodo.filter((proc) => proc.ProcesoId == proceso);

            result = { 
                ...state, 
                ejecucionesProcesosFiltrados: procesosTodo, 
                administradorasFiltradas: administradorasAux, 
                administradoraSeleccionada: action.administradoraSeleccionada };
            break;
        }

        case RESET_STORE: {
            result = Object.assign({}, initialState);
            break;
        }

        case PROCESOS_FILTRADOS_EJEC_DEMANDA: {
            result = { ...state, procesosFiltradoEjecucion: action.procesos };
            break;
        }

        case VALOR_ACTUAL_COMBOS_EJEC_DEMANDA: {
            result = { ...state, combosEjecucionDemanda: action.valorCombos };
            break;
        }

        case AGREGAR_ARCHIVO_EJECUCION_DEMANDA: {

            let archivosEjecucionDemanda = state.archivosEjecDemanda;
            let archivosSelecionado = action.archivo ? archivosEjecucionDemanda.find(x => x.NombreArchivo == action.archivo) : undefined;

            result = {
                ...state,
                archivosEjecDemandaFiltrados: archivosSelecionado,
                archivoEjecDemandaSeleccionado: archivosSelecionado
            };
            break;
        }

        case ERROR_EJECUCIONDEMANDA: {
            result = {
                ...state,
                errorEjecDemanda: action.errorEjecDemanda
            };
            break;
        }

        case SET_BUSQUEDA_ARCHIVOS: {
            result = {
                ...state,
                textArchivo: action.textArchivo
            };
            break;
        }

        case ES_EJECUCION_DEMANDA: {
            result = {
                ...state,
                esEjecucionDemanda: action.valor
            };
            break;
        }        
        

        default: {
            result = state;
            break;
        }
    }

    LogHelper.Out(procesos.name, result);
    return result;
}

export default procesos;
